module.exports = __webpack_public_path__ + "img/logo-header.acd382ca.png";